/**
 * @file Route: passwordrecovery
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "./index.scss";
import "layouts/main";
import { AuthPassword } from "components/Form/Auth/Password";

console.log("Route passwordrecovery/index.js mounted.");

AuthPassword();